import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import "./ContactForm.css";

const Contact = () => {

  const [formData, setFormData] = useState({ name: "", contact: "", email: "", message: "" });


  const handleSubmit = (e) => {
    e.preventDefault();
  //   fetch("https://script.google.com/macros/s/AKfycbwADj80bJLBxiVu7SWNzoL4MoKhWCLEHXMCC6bRNYBc38oqbWdUC1YGxluy2icq5P3wqw/exec", {
     
  //   method: 'POST',
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(formData),
  //   })

  //     .then((response) =>{
  //       if(!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       } return response.json();
  //     })
               
  
  //     .then((data) => {
  //       console.log('Success:', data);
  //       alert('Message sent successfully!');
  //     })
  //     .catch((error) => {
  //     console.error('Error:', error);
  //     alert('Something went wrong. please try agian later.');
  //     });
  // };

  const serviceId = 'service_yjduhnn';
  const templateId = 'template_bc9d2wb';
  const userId = 'GPazn_6Kb0cgcFpgO'; 

  emailjs
    .send(serviceId, templateId, formData, userId)
    .then(() => {
      alert('Message sent successfully!');
      setFormData({ name: '', contact: '', email: '', message: '' });
    })
    .catch((error) => {
      console.error('EmailJS Error:', error);
      alert('Failed to send message. Please try again.');
    });
};



  return (
<section id="contact-form-section" >

    <div className='contact-page'>

<form className="contact-form-section" onSubmit={handleSubmit}>


      <h1><b>Contact us</b></h1>
      <p>Thank you for your interest in Omega Review Services.
       Leave us your details here and we'll get in touch soon.</p>
       <input
            type="text"
            placeholder="Name"
            value={formData.name}
            onChange={(e) =>
              setFormData({ ...formData, name: e.target.value })
            }
    />
    <input
            type="contact Number"
            placeholder="Phone Number"
            value={formData.contact}
            onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
            required
    />
    
    <input
      type="email"
      placeholder="Email"
      value={formData.email}
      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
      required
    />
    <textarea
      placeholder="Message"
      value={formData.message}
      onChange={(e) => setFormData({ ...formData,message: e.target.value })}
      required
    />
    <button type="submit">Submit</button>
  </form>




      {/* Contact Details Section */}
      <div className="contact-details-section">
          <div className="contact-item">
            <i className="fas fa-phone icon"></i>         
          <p className="contact">IND: +91 9553855235<br />
          US: +18014624637
         </p>
        </div>
        <div className="contact-item">          
            <i className="fas fa-envelope icon"></i>
          
          <p className="contact"><a href="mailto:info@omegareviewsolutions.com">Info@omegareviewsolutions.com</a><br />
          <a href="mailto:info@omegareviewsolutions.com">devendra.muddana@omegareviewsolutions.com</a></p>
        </div>
          <div className="address-item">
           
              <i className="fas fa-map-marker-alt icon"></i>
            
            <div>
              <p className="contact">
              10/109, Near Rubik School, <br />
              Nugondapalli, Andhra Pradesh, 521211.
             
              </p>
            </div>
          </div>
          </div>
            
          
       

         {/* Social Media Section */}
      <div className="social-media-section">
        <a href="https://www.instagram.com/omegareviewsolutions?igsh=bDA4bHVqcmUwdHB2" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/omega-review-solutions-528058340?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-linkedin"></i>
        </a>
        <a href="https://www.facebook.com/profile.php?id=61570487395812" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-facebook"></i>
        </a>
      </div>

      </div>
    </section> 
   
  );
};


export default Contact;
